var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDropdownArrow(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4439 8.27045C22.1509 7.97753 21.7535 7.81297 21.3392 7.81297C20.9249 7.81297 20.5275 7.97753 20.2345 8.27045L12.5001 16.0048L4.76576 8.27045C4.47107 7.98583 4.07638 7.82834 3.6667 7.8319C3.25701 7.83546 2.86512 7.99979 2.57542 8.28949C2.28572 8.57919 2.12139 8.97108 2.11783 9.38076C2.11427 9.79045 2.27176 10.1851 2.55639 10.4798L11.3955 19.3189C11.6885 19.6118 12.0858 19.7764 12.5001 19.7764C12.9145 19.7764 13.3118 19.6118 13.6048 19.3189L22.4439 10.4798C22.7368 10.1868 22.9014 9.78946 22.9014 9.37514C22.9014 8.96082 22.7368 8.56346 22.4439 8.27045Z",
    fill: "#8F6F6F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArrow);
export default __webpack_public_path__ + "static/media/dropdown_arrow.8ff3a558cafbd36703b05b8c47e6d72e.svg";
export { ForwardRef as ReactComponent };